import React from 'react';
import { Col, Row } from 'reactstrap';
import Select from 'react-select';
import { DateRangePicker } from 'rsuite';
import 'rsuite/dist/rsuite.min.css';
import moment from 'moment';
import {
  PAYMENT_FAILED_ACTION_STATUSES,
  PAYMENT_FAILED_OPEN_CLOSED_OPTIONS,
  PAYMENT_FAILED_TRIGGER_REASONS,
} from '../../../constants/paymentFailedOrders';

const statusOptions = PAYMENT_FAILED_ACTION_STATUSES.map((status) => ({
  value: status.value,
  label: status.label,
}));

const triggerOptions = [
  { value: '', label: 'All' },
  ...PAYMENT_FAILED_TRIGGER_REASONS.map((trigger) => ({
    value: trigger.value,
    label: trigger.label,
  })),
];

// Countries the signed in user is allowed to see
const getCountryOptions = () => {
  try {
    const user = JSON.parse(localStorage.getItem('authUser') || '{}');
    const list = user?.countryList || {};
    const options = Object.keys(list)
      .filter((code) => code.toLowerCase() !== 'all')
      .map((code) => ({
        value: code.toLowerCase(),
        label: list[code]?.label || code.toUpperCase(),
      }));
    return [{ value: '', label: 'All' }, ...options];
  } catch (error) {
    return [{ value: '', label: 'All' }];
  }
};

// Orders never fail in the future
const disableFutureDates = (date) => date.getTime() > new Date().getTime();

const selectStyles = {
  control: (base) => ({ ...base, minHeight: 32, fontSize: 12 }),
  valueContainer: (base) => ({ ...base, padding: '0 6px' }),
  indicatorsContainer: (base) => ({ ...base, height: 30 }),
  menu: (base) => ({ ...base, fontSize: 12, zIndex: 5 }),
  multiValue: (base) => ({ ...base, fontSize: 11 }),
};

const PaymentFailedOrdersFilters = ({ filters, onChange, onReset }) => {
  const countryOptions = getCountryOptions();

  const setFilter = (patch) => onChange({ ...filters, ...patch });

  // The picker works in Date objects, the filters keep YYYY-MM-DD strings
  const dateRangeValue =
    filters.dateFrom && filters.dateTo
      ? [new Date(filters.dateFrom), new Date(filters.dateTo)]
      : null;

  return (
    <div className="pf-filter-bar mb-3">
      <Row className="g-2 align-items-end">
        <Col xl={2} md={4} xs={12} className="mb-2">
          <label className="form-label">Search</label>
          <input
            type="text"
            className="form-control"
            placeholder="Phone, email, name, order no"
            value={filters.search}
            onChange={(e) => setFilter({ search: e.target.value })}
          />
        </Col>
        <Col xl={3} md={8} xs={12} className="mb-2">
          <label className="form-label">Action Status</label>
          <Select
            isMulti
            options={statusOptions}
            value={statusOptions.filter((option) =>
              filters.actionStatus.includes(option.value),
            )}
            onChange={(selected) =>
              setFilter({ actionStatus: (selected || []).map((item) => item.value) })
            }
            placeholder="All"
            styles={selectStyles}
            classNamePrefix="select2-selection"
          />
        </Col>
        <Col xl={1} md={4} xs={6} className="mb-2">
          <label className="form-label">Trigger</label>
          <select
            className="form-select"
            value={filters.triggerReason}
            onChange={(e) => setFilter({ triggerReason: e.target.value })}
          >
            {triggerOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </Col>
        <Col xl={1} md={4} xs={6} className="mb-2">
          <label className="form-label">State</label>
          <select
            className="form-select"
            value={filters.recordState}
            onChange={(e) => setFilter({ recordState: e.target.value })}
          >
            {PAYMENT_FAILED_OPEN_CLOSED_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </Col>
        <Col xl={1} md={4} xs={6} className="mb-2">
          <label className="form-label">Country</label>
          <select
            className="form-select"
            value={filters.country}
            onChange={(e) => setFilter({ country: e.target.value })}
          >
            {countryOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </Col>
        <Col xl={4} md={8} xs={12} className="mb-2">
          <label className="form-label">Created Date</label>
          <DateRangePicker
            className="w-100"
            placement="auto"
            placeholder="Select a Date Range"
            showOneCalendar={false}
            disabledDate={disableFutureDates}
            value={dateRangeValue}
            onChange={(dates) => {
              if (dates?.[0] && dates?.[1]) {
                setFilter({
                  dateFrom: moment(dates[0]).format('YYYY-MM-DD'),
                  dateTo: moment(dates[1]).format('YYYY-MM-DD'),
                });
              }
            }}
            onClean={() => setFilter({ dateFrom: '', dateTo: '' })}
          />
        </Col>
        <Col xl={2} md={4} xs={12} className="mb-2">
          <button type="button" className="btn btn-sm btn-outline-secondary w-100" onClick={onReset}>
            Reset Filters
          </button>
        </Col>
      </Row>
    </div>
  );
};

export default PaymentFailedOrdersFilters;
